import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormlyModule } from "@ngx-formly/core";
import { CheckboxModule } from "primeng-v17/checkbox";
import { FormElementMapModule } from "../../shared/from-element-map/form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { NewUiFormlyCheckboxComponent } from "./new-ui-formly-checkbox.component";

@Component({
  selector: "app-formly-checkbox",
  templateUrl: "./formly-checkbox.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    FormElementMapModule,
    TestIdDirective,
    FormlyModule,
    NgIf,
  ],
})
export class FormlyCheckboxComponent extends NewUiFormlyCheckboxComponent {}
